import { Pipe, PipeTransform } from '@angular/core';
import { Sim, SimWithUsage } from '../models/sim';
import { LocalizedDatePipe } from '../../../shared/pipes/localized-date.pipe';

@Pipe({
  name: 'preprocessSim'
})
export class PreprocessSimPipe implements PipeTransform {
  constructor(
    private localizedDate: LocalizedDatePipe
  ) {

  }
  transform(sims:  (Sim | SimWithUsage)[], currentLang: string): (Sim | SimWithUsage)[] {
    return sims && sims.map((sim: Sim | SimWithUsage ) => {
      return {
        ...sim,
        link: sim.link && sim.link.replace("CELL_", "") || '',
        lastSeen:  this.localizedDate.transform(sim.lastSeen, currentLang),
        simConfig: {
          ...sim.simConfig,
          startDate: this.localizedDate.transform(sim.simConfig.startDate, currentLang),
          period: `${this.localizedDate.transform(sim.simConfig.currentBeginPeriod, currentLang)} - ${this.localizedDate.transform(sim.simConfig.currentEndPeriod, currentLang)}`
        }
      }
    });
  }

}
